<template>
  <div class="wrapper">
    <div class="learn-menu" ref="menu">
      <h4 class="learn-menu-list">目录</h4>
      <el-tree
        class="el-tree"
        :data="menData"
        :props="defaultProps"
        :current-node-key='nowNode'
        ref="treeList"
        @node-click="handleNodeClick"
        @current-change='changeNode'
        @setCheckedKeys='setNode'
        :highlight-current="true"
        :render-after-expand="false"
        :accordion="true"
      ></el-tree>
    </div>
    <div ref="content">
      <router-view></router-view>
    </div>
  </div>
</template>

<script>
export default {
  components: {},
  data() {
    return {
      nowNode:'',
      menData: [
        {
          name: "learn1",
          label: "新手入门须知"
        },
        {
          label: "工作台",
          children: [
            {
              name: "learn2",
              label: "工作台介概述"
            },
            {
              name: "learn3",
              label: "数据统计与名词解释"
            }
          ]
        },
        {
          label: "候选人",
          children: [
            {
              name: "learn4",
              label: "招聘管理流程与名词解释"
            },
            {
              name: "learn37",
              label: "候选人详情页"
            },
            {
              name: "learn5",
              label: "添加/导入/导出候选人"
            },
            {
              name: "learn6",
              label: "筛简历"
            },
            {
              name: "learn38",
              label: "待面试"
            },
            {
              name: "learn7",
              label: "应聘登记表"
            },
            {
              name: "learn9",
              label: "面试中"
            },
            {
              name: "learn11",
              label: "淘汰"
            },
            // {
            //   name: "learn8",
            //   label: "安排面试"
            // },
            {
              name: "learn10",
              label: "发Offer"
            },
            {
              name: "learn39",
              label: "待入职"
            },

            // {
            //   name: "learn12",
            //   label: "人才库"
            // }
          ]
        },
        {
          label: "职位管理",
          children: [
            {
              name: "learn13",
              label: "添加/导入职位"
            },
            {
              name: "learn14",
              label: "一键发布职位至招聘渠道"
            },
            {
              name: "learn15",
              label: "编辑职位"
            },
            {
              name: "learn40",
              label: "删除/停止招聘岗位"
            },
            {
              name: "learn41",
              label: "招聘岗位审批"
            },
            {
              name: "learn42",
              label: "导出职位"
            }
          ]
        },
        {
          label: "人才库",
          children: [
            {
              name: "learn16",
              label: "自定义人才库"
            },
            {
              name: "learn17",
              label: "公共人才库"
            },
            {
              name: "learn18",
              label: "黑名单"
            },
            {
              name: "learn19",
              label: "入职人才库"
            },
            // {
            //   name: "learn20",
            //   label: "淘汰原因"
            // },
            // {
            //   name: "learn21",
            //   label: "放弃入职原因"
            // },
            // {
            //   name: "learn22",
            //   label: "招聘平台对接"
            // },
            // {
            //   name: "learn23",
            //   label: "审批流程设置"
            // }
          ]
        },
        {
          label: "增值服务",
          children: [
            {
              name: "learn32",
              label: "智能背调"
            },
            {
              name: "learn33",
              label: "背调记录"
            },
            {
              name: "learn34",
              label: "交易记录"
            },
            {
              name: "learn20",
              label: "充值记录"
            }
          ]
        },
        {
          label: "统计报表",
          children: [
            {
              name: "learn25",
              label: "招聘概览"
            },
            {
              name: "learn26",
              label: "招聘需求"
            },
            {
              name: "learn27",
              label: "招聘漏斗"
            },
            {
              name: "learn28",
              label: "招聘完成率"
            },
            {
              name: "learn29",
              label: "招聘转换率"
            },
            {
              name: "learn30",
              label: "招聘影响因素"
            },
            {
              name: "learn31",
              label: "招聘全数据"
            }
          ]
        },
        {
          label: "招聘日历",
          children: [
            {
              name: "learn24",
              label: "招聘日历"
            }
          ]
        },
        
        {
          label: "设置",
          children: [
            {
              name: "learn35",
              label: "权限设置"
            },
            {
              name: "learn36",
              label: "招聘平台对接"
            },
            {
              name: "learn43",
              label: "模板设置"
            },
            {
              name: "learn44",
              label: "审批管理"
            },
            {
              name: "learn45",
              label: "标签管理"
            },
          ]
        }
      ],
      defaultProps: {
        children: "children",
        label: "label"
      }
    };
  },
  computed: {},
  watch: {},
  methods: {
    handleNodeClick(data) {
    //   console.log(data);
      if (data.name) {
        this.$router.push(data.name);
        this.setNode(data.name)
      }
    },
    changeNode(a,b){
        console.log(a,b)
    },
    setNode(a){
        console.log(a,'set')
    }
  },
  created() {
      this.$nextTick(function(){
                this.$refs.treeList.setCurrentKey(2);  //"treeList"是你自己在树形控件上设置的 ref="treeList" 的名称
            })
  },
  mounted() {
    //   this.$nextTick( () => {
    //       this.$refs.menu.setCurrentKey('learn2')
    //   })
    //    window.addEventListener("scroll",()=>{
    //        let scrollTop = window.pageYOffset || document.documentElement.scrollTop || document.body.scrollTop;
    //        console.log(scrollTop)
    //         if (scrollTop > 88) {
    //             if(this.$refs.menu){
    //                 this.$refs.menu.style.position = 'fixed'
    //                 this.$refs.menu.style.top = '0'
    //             }
    //             if(this.$refs.content){
    //                 this.$refs.content.style.marginLeft = '224px'
    //             }
    //         }else{
    //             if(this.$refs.menu){
    //                 this.$refs.menu.style.position = 'static'
    //             }
    //             if(this.$refs.content){
    //                 this.$refs.content.style.marginLeft = '0'
    //             }
    //         }
    //    });
  },
  destroyed() {
    //   document.removeEventListener('scroll', this.handleScroll)
  }
};
</script>



// WEBPACK FOOTER //
// src/components/pages/learn.vue